import React from "react";
import { useParams } from "react-router";

const Booking = () => {
  const { serviceId } = useParams();

  return (
    <div className="m-5 p-5">
      <h1>
        <span style={{ fontFamily: "popins" }} className="text-primary m-5 ">
          Service Details
        </span>{" "}
        <br />{" "}
      </h1>
      <p className="w-50 mx-auto">{serviceId}</p>
      <button className="btn btn-danger mt-5">Book For Apoinment</button>
    </div>
  );
};

export default Booking;
